<div class="d-flex flex-column m-0 w-100">
<irreversible-operation-banner class="m-0"></irreversible-operation-banner>
@if (this.appService.getShowHeaderAndFooter()) {
<header>
  @if (getAppThemeName() === 'db') {
  <db-app-header></db-app-header>
  }
  @if (getAppThemeName() === 'pb') {
  <pb-app-header></pb-app-header>
  }
  @if (getAppThemeName() === 'nb') {
  <nb-app-header></nb-app-header>
  }
</header>
}
<main class="d-flex flex-row {{getAppThemeName() === 'nb' ? 'bg-color-nb-grey-200' : ''}}">
  <router-outlet></router-outlet>
</main>
@if (this.appService.getShowHeaderAndFooter()) {
<footer>
  <app-footer></app-footer>
</footer>
}
</div>
